export const typeToScopeTypeName = {
  course: 'COURSE' as const,
  partner: 'PARTNER' as const,
  program: 'DEGREE' as const,
};

export default typeToScopeTypeName;
